import { PeopleAltOutlined, PersonOutline, Restore } from '@material-ui/icons';
import { PinIcon } from '@workboard/wobo-ui';
import React from 'react';
import { FilterChip } from './teams.types';

export const getInitialAdvanceArr = (t: (key: string) => string) => [
  {
    id: '1',
    label: t('Active'),
    isSelected: false,
    filterRef: 'active',
    type: t('State'),
    filterKey: 'status',
  },
  {
    id: '2',
    label: t('Archived (hidden by default)'),
    isSelected: false,
    filterRef: 'archived',
    type: t('State'),
    filterKey: 'status',
  },
  {
    id: '3',
    label: t('Functional teams'),
    isSelected: false,
    filterRef: 'functional',
    type: t('Team type'),
    filterKey: 'type',
  },
  {
    id: '4',
    label: t('Dynamic teams'),
    isSelected: false,
    filterRef: 'dynamic',
    type: t('Team type'),
    filterKey: 'type',
  },
  {
    id: '5',
    label: t('Manager/ Co-manager'),
    isSelected: false,
    filterRef: 'manager',
    type: t('Role'),
    filterKey: 'myRole',
  },
  {
    id: '6',
    label: t('Admin'),
    isSelected: false,
    filterRef: 'admin',
    type: t('Role'),
    filterKey: 'myRole',
  },
  {
    id: '7',
    label: t('Member'),
    isSelected: false,
    filterRef: 'member',
    type: t('Role'),
    filterKey: 'myRole',
  },
  {
    id: '8',
    label: t('Executive viewer'),
    isSelected: false,
    filterRef: 'executiveViewer',
    type: t('Role'),
    filterKey: 'myRole',
  },
];

export const getInitialChipList = (
  t: (key: string) => string,
): FilterChip[] => [
  {
    name: t('My teams'),
    id: 1,
    icon: <PersonOutline />,
    label: t('My teams'),
    isActive: true,
    filterRef: 'my',
  },
  {
    name: t('Recents'),
    id: 2,
    icon: <Restore />,
    label: t('Recents'),
    isActive: false,
    filterRef: 'recent',
  },
  {
    name: t('Favorites'),
    id: 3,
    icon: <PinIcon />,
    label: t('Favorites'),
    isActive: false,
    filterRef: 'favorite',
  },
  {
    name: t('All teams'),
    id: 4,
    icon: <PeopleAltOutlined />,
    label: t('All teams'),
    isActive: false,
    filterRef: 'all',
  },
];

// Keep the original exports for backward compatibility, but they should be deprecated
export const initialAdvanceArr = [
  {
    id: '1',
    label: 'Active',
    isSelected: false,
    filterRef: 'active',
    type: 'State',
    filterKey: 'status',
  },
  {
    id: '2',
    label: 'Archived (hidden by default)',
    isSelected: false,
    filterRef: 'archived',
    type: 'State',
    filterKey: 'status',
  },
  {
    id: '3',
    label: 'Functional teams',
    isSelected: false,
    filterRef: 'functional',
    type: 'Team type',
    filterKey: 'type',
  },
  {
    id: '4',
    label: 'Dynamic teams',
    isSelected: false,
    filterRef: 'dynamic',
    type: 'Team type',
    filterKey: 'type',
  },
  {
    id: '5',
    label: 'Manager/ Co-manager',
    isSelected: false,
    filterRef: 'manager',
    type: 'Role',
    filterKey: 'myRole',
  },
  {
    id: '6',
    label: 'Admin',
    isSelected: false,
    filterRef: 'admin',
    type: 'Role',
    filterKey: 'myRole',
  },
  {
    id: '7',
    label: 'Member',
    isSelected: false,
    filterRef: 'member',
    type: 'Role',
    filterKey: 'myRole',
  },
  {
    id: '8',
    label: 'Executive viewer ',
    isSelected: false,
    filterRef: 'executiveViewer',
    type: 'Role',
    filterKey: 'myRole',
  },
];

export const initialChipList: FilterChip[] = [
  {
    name: 'My teams',
    id: 1,
    icon: <PersonOutline />,
    label: 'My teams',
    isActive: true,
    filterRef: 'my',
  },
  {
    name: 'Recents',
    id: 2,
    icon: <Restore />,
    label: 'Recents',
    isActive: false,
    filterRef: 'recent',
  },
  {
    name: 'Favorites',
    id: 3,
    icon: <PinIcon />,
    label: 'Favorites',
    isActive: false,
    filterRef: 'favorite',
  },
  {
    name: 'All teams',
    id: 4,
    icon: <PeopleAltOutlined />,
    label: 'All teams',
    isActive: false,
    filterRef: 'all',
  },
];
